import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
  ReferenceArea,
} from "recharts";
import { rsi, monthYearLabel, fullDateLabel, monthlyTicks } from "../../lib/indicators";

export default function RsiChart({ data }) {
  const closes = data.map((d) => Number(d.close));
  const values = rsi(closes, 14);

  const series = data.map((d, i) => ({
    raw_date: d.quote_date,
    rsi: values[i] != null ? +values[i].toFixed(2) : null,
  }));
  const ticks = monthlyTicks(series);

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
          RSI (14) · momentum
        </div>
        <div className="flex items-center gap-3 text-[10px] text-muted-foreground">
          <span><span className="inline-block w-2 h-2 mr-1 bg-sell rounded-sm align-middle" />Sobrecompra ≥ 70</span>
          <span><span className="inline-block w-2 h-2 mr-1 bg-buy rounded-sm align-middle" />Sobrevenda ≤ 30</span>
        </div>
      </div>
      <div className="h-[180px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={series} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="oklch(0.92 0.004 286.32)" vertical={false} />
            <XAxis dataKey="raw_date" ticks={ticks} tickFormatter={monthYearLabel} interval={0} tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" />
            <YAxis
              domain={[0, 100]}
              ticks={[0, 30, 50, 70, 100]}
              tick={{ fontSize: 10 }}
              stroke="oklch(0.552 0.016 285.938)"
              width={35}
            />
            <Tooltip
              contentStyle={{ background: "var(--popover)", border: "1px solid var(--border)", fontSize: 12 }}
              labelFormatter={fullDateLabel}
              formatter={(v) => [Number(v).toFixed(2), "RSI"]}
            />
            <ReferenceArea y1={70} y2={100} fill="oklch(0.55 0.21 25)" fillOpacity={0.06} />
            <ReferenceArea y1={0} y2={30} fill="oklch(0.58 0.13 145)" fillOpacity={0.06} />
            <ReferenceLine y={70} stroke="oklch(0.55 0.21 25)" strokeDasharray="3 3" />
            <ReferenceLine y={30} stroke="oklch(0.58 0.13 145)" strokeDasharray="3 3" />
            <ReferenceLine y={50} stroke="oklch(0.552 0.016 285.938)" strokeDasharray="1 4" />
            <Line type="monotone" dataKey="rsi" stroke="oklch(0.52 0.105 223.128)" strokeWidth={1.8} dot={false} isAnimationActive={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
